export default "__VITE_ASSET__CFnuMksa__"